import React, {useMemo} from 'react';
import {useParams} from 'react-router-dom';

import {getLink} from '@appComponents/Link';
import {routes} from '@constants/routes';
import {useModalRouting} from '@utils/hooks/useModalRouting';

import ArgosJobLiveControlHistoryLoader from './ArgosJobLiveControlHistoryLoader';

export const ArgosJobLiveControlModalRouting = () => {
    const {jobId} = useParams();

    const routesMap = useMemo(() => [
        {
            path: routes.argosJobLiveControl.jobHistory.path,
            render: () => <ArgosJobLiveControlHistoryLoader type='job' jobId={jobId}/>,
            size: 'large',
        },
        {
            path: routes.argosJobLiveControl.streamHistory.path,
            render: () => <ArgosJobLiveControlHistoryLoader type='stream' jobId={jobId}/>,
            size: 'large',
        },
    ], [jobId]);

    useModalRouting({
        routesMap,
        indexUrl: getLink('argosJobLiveControl.index'),
    });

    return null;
};

export default ArgosJobLiveControlModalRouting;
